import { FC } from 'react';
import { ToyCardLoaded } from '@components/Cards/ToyCard/ToyCardLoaded';
import { useToyData } from '@hooks/useToyData';
import { toy } from '@specs/specs';
import { ToyCardLoading } from '@components/Cards/ToyCard/ToyCardLoading';
interface Props {
  id: toy['id'];
}
export const ToyCard: FC<Props> = ({
  id
}) => {
  const {
    haveFigurinesForSale,
    myFirstStoreItem,
    isLoading,
    artist,
    collection,
    firstStoreItem,
    toy,
    artistWithCollaboratorsIds
  } = useToyData({
    toyId: id
  });
  if (isLoading) return <ToyCardLoading />;
  if (!toy) return null;
  return <ToyCardLoaded {...toy} artist={artist} artistWithCollaborators={artistWithCollaboratorsIds} collection={collection} haveFigurinesForSale={haveFigurinesForSale} myFirstStoreItem={myFirstStoreItem} firstStoreItem={firstStoreItem} data-sentry-element="ToyCardLoaded" data-sentry-component="ToyCard" data-sentry-source-file="ToyCard.tsx" />;
};